/* eslint-disable react/jsx-props-no-spreading */
import type { ReactElement } from 'react';
import React from 'react';
import type { TippyProps } from '@tippyjs/react';
import Tippy from '@tippyjs/react';
import './styles/tooltips.scss';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import { isEmpty } from 'lodash';

type Props = {
  tippyOptions?: TippyProps;
  content: React.ReactNode;
  children: ReactElement;
};

export const TippyToolTip: React.FC<Props> = (props) => {
  const { tippyOptions, content, children } = props;
  const tippyOptionsUpdated: TippyProps = {
    placement: tippyOptions?.placement ?? 'auto',
    interactive: true,
    allowHTML: true,
    content,
    className: 'tippy-tooltip light-theme',
    theme: 'light',
    ...tippyOptions,
  };

  return isEmpty(content) ? (
    <>{children}</>
  ) : (
    <Tippy {...tippyOptionsUpdated}>{children}</Tippy>
  );
};

export default TippyToolTip;
